<template>
  <div class="process-section">
    <!-- 标题区域 (靠左对齐) -->
    <div class="header">
      <div class="tag">INVESTIGATION PROTOCOL</div>
      <h2 class="title">How We <span class="gradient">Recover Your Funds</span></h2>

      <!-- 居中带分割线的装饰 -->
      <div class="divider-container">
        <div class="line"></div>
        <span class="square-icon">[■]</span>
        <div class="line"></div>
      </div>
    </div>

    <!-- 流程步骤区域 -->
    <div class="steps-wrapper">
      <div class="connect-line"></div>

      <div class="steps-grid">
        <div v-for="(step, index) in steps" :key="index" class="step-item">
          <div class="icon-circle">
            <span class="icon">{{ step.icon }}</span>
          </div>
          <div class="step-num">STEP #{{ index + 1 }}</div>
          <h3 class="step-title">{{ step.title }}</h3>
          <p class="step-desc">{{ step.desc }}</p>
        </div>
      </div>
    </div>

    <!-- 底部统计条 -->
    <div class="stats-bar">
      <div v-for="(stat, index) in stats" :key="index" class="stat-item">
        <div class="num">{{ stat.num }}</div>
        <div class="label">{{ stat.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessSteps',
  data() {
    return {
      steps: [
        { icon: '📋', title: 'Case Submission', desc: 'Submit your case details securely. Our team reviews your situation within 24 hours and assesses recovery viability at no cost.' },
        { icon: '🔍', title: 'Blockchain Investigation', desc: 'Our forensic analysts trace stolen assets across wallets, chains, and exchanges using advanced blockchain intelligence tools and analytics platforms.' },
        { icon: '⚖️', title: 'Legal Action', desc: 'Compiled evidence is submitted to appropriate legal and enforcement channels, initiating formal recovery proceedings through regulated authorities.' },
        { icon: '✅', title: 'Recovery & Closure', desc: 'Assets are secured and returned. You receive a full case report and post-recovery security consultation to protect against future threats.' }
      ],
      stats: [
        { num: '5,000+', label: 'CASES REVIEWED' },
        { num: '$1.83M', label: 'FUNDS RECOVERED' },
        { num: '94.7%', label: 'SUCCESS RATE' },
        { num: '40+', label: 'COUNTRIES SERVED' },
        { num: '24/7', label: 'LIVE MONITORING' },
        { num: '10+', label: 'ACTIVE SERVICES' }
      ]
    };
  }
}
</script>

<style scoped>
.process-section {
  background-color: #05070e;
  padding: 100px 5%;
  color: #fff;
}

/* 标题区域：靠左对齐 */
.header {
  text-align: left;
  margin-bottom: 60px;
}

.tag {
  color: #00ff88;
  font-size: 0.8rem;
  /* 字体小一点 */
  letter-spacing: 2px;
  margin-bottom: 10px;
  text-transform: uppercase;
  font-weight: bold;
}

.title {
  font-size: 2.8rem;
  /* 字体小一点 */
  font-weight: 800;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #00ff88, #4fd1c5);
  -webkit-background-clip: text;
  color: transparent;
}

/* 居中分割线样式 */
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.15);
  /* 淡淡的线 */
}

.divider-container .square-icon {
  color: #00ff88;
  font-size: 0.8rem;
  margin: 0 15px;
  font-family: monospace;
}

/* 步骤区域 */
.steps-wrapper {
  position: relative;
  max-width: 1200px;
  margin: 0 auto 80px;
}

.connect-line {
  position: absolute;
  top: 35px;
  left: 12.5%;
  right: 12.5%;
  height: 2px;
  background-color: #00ff88;
  z-index: 1;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  position: relative;
  z-index: 2;
}

.step-item {
  text-align: center;
  padding: 0 10px;
}

.icon-circle {
  width: 80px;
  height: 80px;
  background-color: #0d1117;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 30px;
}

.icon {
  font-size: 2.5rem;
}

.step-num {
  color: #00ff88;
  font-family: monospace;
  font-size: 0.9rem;
  letter-spacing: 1px;
  margin-bottom: 15px;
}

.step-title {
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 15px;
}

.step-desc {
  color: #a0b3cc;
  font-size: 1rem;
  line-height: 1.6;
}

/* 统计条 */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  background: rgba(13, 17, 23, 0.8);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.stat-item {
  text-align: center;
  padding: 30px 10px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.stat-item:last-child {
  border-right: none;
}

.num {
  color: #00ff88;
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 10px;
}

.label {
  color: #a0b3cc;
  font-size: 0.85rem;
  letter-spacing: 1px;
}

/* 响应式 */
@media (max-width: 1200px) {
  .steps-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 60px 30px;
  }

  .connect-line {
    display: none;
  }

  .stats-bar {
    grid-template-columns: repeat(3, 1fr);
  }

  .stat-item:nth-child(3n) {
    border-right: none;
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }

  .steps-grid {
    grid-template-columns: 1fr;
  }

  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
  }

  .stat-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .stat-item:nth-child(even) {
    border-right: none;
  }
}
</style>